export const KV_PLUGIN_NAME = "kv";
